import { Box, styled } from '@mui/material';

// Zona de formularios del card de auth. En md+ los paneles (login/registro) van
// absolutos y deslizan con transform; cada panel scrollea por dentro (el registro
// de 7 campos no anima height ni desborda el card).
const StyledAuthFormZone = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: 0,
  minWidth: 0,
  position: 'relative',
  [theme.breakpoints.up('md')]: {
    flexBasis: 0
  }
}));

export default StyledAuthFormZone;
